<template>
  <div id="system-journal-setting-general-alert">
    <ipub-model :title="params.id ? 'Edit Manuscript Alert':'Add New Article Type Alert'"
                width="800px"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel">
      <div class="ipub-p2 mar-b-10">
        <ipub-form ref="journal-option-form"
                   :model="params"
                   :rules="rules">
          <ipub-row :gutter="12">
            <ipub-col :span="12"
                      style="margin-bottom:16px">
              <div class="line-h-40 fw-bd nowrap">Manuscript Type
                <font class="key-color">*</font>
              </div>
              <ipub-select v-model="aTypeCodeArr"
                           mode="multiple"
                           :clear="true"
                           @change="typeChange"
                           placeholder="Select Article Status">
                <template v-for="(value, key) in aType">
                  <ipub-select-option v-if="key!=='UNCOMMITTED'"
                                      @select="selectOption"
                                      :key="value.code"
                                      :value="value.code">
                    {{ value.name }}
                    <template v-if="value.otherName"> ({{value.otherName}})</template>
                  </ipub-select-option>
                </template>
              </ipub-select>
            </ipub-col>
          </ipub-row>
          <div v-if="params.articleTypeList"
               class="mar-b-16 ipub-p2">
            <ipub-label v-for="(item,key) in params.articleTypeList"
                        :key="item.id"
                        circle
                        active
                        style="margin-right: 10px;padding: 5px"
                        type="default"
                        class="mar-b-10">
              <span class="ipub-p2">{{item.name}}</span>
              <ipub-icon type="iconClose"
                         class="mar-l-10 ipub-cursor-pointer"
                         @click="del(key)" />
            </ipub-label>
          </div>
          <div class="ipub-p2 fw-bd mar-b-10">Rules</div>
          <div class="flex"
               style="align-items:center;">
            <div>
              <ipub-radio-group v-model="params.symbolType">
                <ipub-radio value="LTE"
                            class="ipub-h4 mar-b-16 flex"
                            style="align-items:center">
                  <span class="mar-l-10"> ≤ </span>
                </ipub-radio>
                <ipub-radio value="GT"
                            class="ipub-h4 mar-b-16 flex"
                            style="align-items:center;margin-left:0">
                  <span class="mar-l-10"> ＞ </span>
                </ipub-radio>
              </ipub-radio-group>
            </div>
            <div class="mar-l-20">
              <div>
                <ipub-form-item prop="number"
                                style="margin-bottom:0;"
                                label="">
                  <ipub-input placeholder="Amount"
                              number
                              :fixed="0"
                              v-model.trim="params.number" />
                </ipub-form-item>
              </div>
            </div>
            <div class="mar-l-20">
              <ipub-radio-group v-model="params.type"
                                class="mar-l-16">
                <ipub-radio value="VOLUME"
                            class="ipub-p2 mar-b-16 flex"
                            style="align-items:center">
                  <span class="mar-l-10"> / Volume </span>
                </ipub-radio>
                <ipub-radio value="ISSUE"
                            class="ipub-p2 mar-b-16 flex"
                            style="align-items:center;margin-left:0">
                  <span class="mar-l-10"> / Issue </span>
                </ipub-radio>
              </ipub-radio-group>
            </div>

          </div>

        </ipub-form>
      </div>

    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { settingJournalAtypeAlert, settingAtype } from '@/api/setting'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      params: {
      },
      rules: {},
      aType: {},
      aTypeCodeArr: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      publisherId: 'getPublisherId'
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
        this.aTypeCodeArr = []
      } else {
        // this.params = JSON.parse(JSON.stringify(this.inputData))
        if (this.inputData.id) {
          this.getData()
        }
      }
    }
  },
  mounted () {
    this.getAtype()
    this.getRules()
  },
  methods: {
    async getAtype () {
      const data = await settingAtype.getAll()
      this.aType = data
    },
    async getData () {
      const data = await settingJournalAtypeAlert.query(this.inputData.id)
      this.aTypeCodeArr = data.articleTypeList ? data.articleTypeList.map(item => item.code) : []
      this.params = data
    },
    del (index) {
      this.params.articleTypeList.splice(index, 1)
      this.aTypeCodeArr = this.params.articleTypeList ? this.params.articleTypeList.map(item => item.code) : []
    },
    async confirm () {
      const data = Object.assign(this.params, {
        articleType: this.aTypeCodeArr.toString(),
        journalId: this.journalId
      })
      const flag = this.$refs['journal-option-form'].validate()
      if (!flag) {
        return
      }
      if (!data.articleType) {
        this.$message.error({ title: 'Error', content: 'Manuscript Type is empty!' })
        return
      }
      if (this.params.id) {
        await settingJournalAtypeAlert.edit(data.id, data)
      } else {
        await settingJournalAtypeAlert.add(data)
      }
      this.$message.success({ title: 'Success', content: 'This Manuscript Alert has been Saved!' })
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
    },
    typeChange (val) {
      const index = val.indexOf(this.currentOp.code)
      if (index < 0) {
        this.params.articleTypeList.splice(index, 1)
      } else {
        this.params.articleTypeList.push(this.currentOp)
      }
    },
    selectOption (op) {
      const item = this.aType.filter(item => item.code === op) || []
      this.currentOp = item[0] || {}
    },
    getRules () {
      this.rules = {
        number: [
          {
            min: 1, message: 'The number can not less 0!'
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
